(function () {

  // const options = {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: [0.75]
  }

  function callback (entries, observer) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].intersectionRatio > 0 ) {
        entries[i].target.classList.remove('io-hidden');
      } else {
        entries[i].target.classList.add('io-hidden');
      }
    }
  }

  function init() {
    // create observer
    var observer = new IntersectionObserver(callback, options);

    // add observer to target images
    var imgsFadeIn = document.getElementsByClassName("io-fade-in");
    for (var i = 0; i < imgsFadeIn.length; i++) {
      observer.observe( imgsFadeIn[i] );
    }
  }

  window.addEventListener('load', init, false);
}());
